import * as React from "react";
const SvgArrowRightPagination = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="#252525"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6.4 4.8 9.6 8l-3.2 3.2"
    />
  </svg>
);
export default SvgArrowRightPagination;
